export const Colors: DarkLightTheme = {
  dark: {
    error: '#ed4747',
    warning: '#eded47',
    success: '#2ed15f',
    info: '#478fed',
    text: {
      darker: '#1a1a1a',
      dark: '#3b3b3b',
      main: '#faf4f0',
      light: '#828282',
      lighter: '#fff',
    },
    primary: {
      darker: '#cf5711',
      dark: '#de631b',
      main: '#EE6D20',
      light: '#ff9555',
      lighter: '#ffccad',
    },
    environment: {
      darker: '#111211',
      dark: '#222422',
      main: '#303330',
      light: '#414541',
      lighter: '#5b615b',
    },
  },
  light: {
    error: '#ed4747',
    warning: '#eded47',
    success: '#47ed6e',
    info: '#478fed',
    text: {
      darker: '#141414',
      dark: '#262625',
      main: '#303030',
      light: '#a8a8a8',
      lighter: '#ffffff',
    },
    primary: {
      darker: '#cf5711',
      dark: '#de631b',
      main: '#EE6D20',
      light: '#ff9555',
      lighter: '#ffccad',
    },
    environment: {
      darker: '#e9d0c5',
      dark: '#f0dcd4',
      main: '#e6e6e6',
      light: '#efefef',
      lighter: '#ffffff',
    },
  },
};

export default Colors;
